import { useCallback, useState } from 'react';
import apiClient from '@utils/api-client';
import { updatePublicUploadUrlApiInternalSubcontractorSubcontractWorkStatusPath } from '@routes';
const useUpdateEasyUploadLink = (id) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const updateEasyUploadLink = useCallback(() => {
        const controller = new AbortController();
        setLoading(true);
        return apiClient
            .patch(updatePublicUploadUrlApiInternalSubcontractorSubcontractWorkStatusPath(id), undefined, {
            signal: controller.signal
        })
            .then((response) => {
            const result = response.data.data;
            setData(result);
        })
            .catch((err) => {
            if (!controller.signal.aborted) {
                setData(null);
                setError(err);
                throw err;
            }
        })
            .finally(() => {
            if (!controller.signal.aborted) {
                setLoading(false);
            }
        });
    }, [id]);
    return { updateEasyUploadLink, data, loading, error };
};
export default useUpdateEasyUploadLink;
